import * as React from 'react'
import {pluralize} from '@frontrow/console/src/entities/helpers/string-helper'

import * as style from './district-licenses-summary.module.scss'

type Props = {
  numSchools: number
  numMathLicenses: number
  numElaLicenses: number
  numSocialStudiesLicenses: number
  numScienceLicenses: number
}

export default function DistrictLicensesSummary(props: Props): React.ReactElement {
  const {
    numSchools,
    numMathLicenses,
    numElaLicenses,
    numSocialStudiesLicenses,
    numScienceLicenses
  } = props

  return (
    <div className={style.licensesSummaryContainer}>
      <div className={style.licensesSummary}>
        {numSchools} {pluralize(numSchools, 'school', 'schools')}
      </div>
      <div className={style.licensesSummary}>Math: {numMathLicenses}</div>
      <div className={style.licensesSummary}>ELA: {numElaLicenses}</div>
      <div className={style.licensesSummary}>Social Studies: {numSocialStudiesLicenses}</div>
      <div className={style.licensesSummary}>Science: {numScienceLicenses}</div>
    </div>
  )
}
